import {
    FETCH_MAIN_FACETS,
    ACTIVATE_MAIN_FACET,
    ACTIVATE_GROUP,
    FETCH_FACETS,
    ACTIVATE_FACET,
    FETCH_MIDDLEFACETS,
    ACTIVATE_GROUP_WITH_MIDDLEFACETS,
    ADD_TO_AVAILABLE_GROUPS,
    RESET_AVAILABLE_GROUPS,
    DEACTIVATE_GROUP_WITH_MIDDLEFACETS,
    DEACTIVATE_FACET,
    REMOVE_FROM_AVAILABLE_GROUPS,
    CLEAR_ACTIVE_GROUP,
    ACTIVATE_FACET_MULTI,
    DEACTIVATE_FACET_MULTI,
    RESET_SEARCH,
    SHOW_RESULTS,
    GOTO_PAGE,
    SET_SEARCH_VALUE,
    FETCH_AUTOCOMPLETE_RESULTS,
    CLOSE_OVERLAY,
    UNSET_SEARCH_VALUE,
    SUBMIT_SEARCH_VALUE,
    OPEN_OVERLAY,
    SHOW_MENU,
    HIDE_MENU,
    TOGGLE_MENU,
    INITIALIZE,
    SET_INITIAL_ACTIVE_FILTERS,
    SET_MOBILE,
    SET_KEYBOARD_POSITION,
    DEACTIVATE_DEPENDENT_FACETS,
    CACHE_RESPONSE,
    MAIN_FACETS_ERROR,
    SET_RESULTS_ERROR,
    UNSET_RESULTS_ERROR,
    SET_ACTIVE_FILTER_ID, UPDATE_MAIN_FACETS_COUNT,
} from "../Actions/ActionTypes";


const initialState = {
    initialized: false,
    errors: {},
    responseCache: {},
    loading: false,
    facets: {},
    activeFilters: {},
    activeGroup: null,
    activeGroupWithMiddlefacets: null,
    availableGroups: null,
    searchResults: [],
    thisPage: 1,
    lastPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    showDesktopMenu: false,
    showMobileMenu: false,
    isMobile: true,
    selectionCache: [],             // Stores all selections on each main facet. Chose nivå VGS on utdanninger, switch to yrker, switch back to utdanninger - nivå VGS should be selected

    // autocomplete search related:
    acSearchInputValue: '',
    acSearchResult: null,
    acOverlay: false,
    submittedSearchValue: '',
    acKeyboardPosition: null,
};

const _INITIALIZE = (state, payload) => {
    return {...state, initialized: true, loading: true};
};

const _CACHE_RESPONSE = (state, payload) => {
    const responseCache = {...state.responseCache};
    const url = payload.url;
    const response = payload.response;
    responseCache[url] = response;
    return {...state, responseCache: responseCache};
};

const _SET_INITIAL_ACTIVE_FILTERS = (state, payload) => {
    const filters = payload.filters;
    return {...state, activeFilters: filters};
};

const _SET_ACTIVE_FILTER_ID = (state, payload) => {
    const activeFilters = {...state.activeFilters}
    activeFilters[payload.facetName].id = payload.id;
    let newCache = {...state.selectionCache};
    
    if (!newCache[activeFilters.hovedfasett.id]) newCache[activeFilters.hovedfasett.id] = {}; // If facet is not present in cache
    
    Object.keys(activeFilters).forEach(key => { // Cache all selections
        if (key !== "hovedfasett") {
            newCache[activeFilters.hovedfasett.id][key] = activeFilters[key];
        }
    })
    return {...state, activeFilters: activeFilters, selectionCache: newCache};
};

const _GET_MAIN_FACETS = (state, payload) => {
    return {...state, facets: payload.mainFacets};
};

const _MAIN_FACETS_ERROR = (state, payload) => {
    let errors = {...state.errors};
    errors.hovedfasett = payload;
    return {...state, errors: errors};
};

const _UPDATE_MAIN_FACETS_COUNT = (state, payload) => {
    const facets = {...state.facets};
    for (const [, item] of Object.entries(facets)) {
        const value = item.value;
        item.count = payload.mainFacets[value];
    }
    return {...state, facets: facets};
};

const _ACTIVATE_MAIN_FACET = (state, payload) => {
    const id = payload.id;
    const value = payload.value;

    // When a main facet is clicked, all the facet filters are resetting, and the new value is set.
    let activeFilters = state.activeFilters;
    // let prevSelection = {...activeFilters};

    // If there are BOTH query_value AND query_fields, they should be reset.
    // But if there is ONLY query_value, it should not be reset.
    let queryValue = null;
    if (activeFilters.query_value !== undefined) { // If there is query_value
        if (activeFilters.query_fields === undefined) { // ...and there is NO query_fields
            queryValue = activeFilters.query_value; // ...keep the query_value
        }
    }

    // Reset all the filters,
    activeFilters = {
        hovedfasett: {
            id: id,
            value: value
        }
    };
    if (state.selectionCache[payload.id]) { // If there has been cached some selections earlier on this facet, apply those. 
        activeFilters["hovedfasett"] = {"id": id, "value": value};
        Object.keys(state.selectionCache[payload.id]).forEach(key => { // Convert to correct formating for activeFilters. 
            activeFilters[key] = state.selectionCache[payload.id][key];
        })
    }

    // Loop over all earlier selections and check if there are common sub-filters to be kept
    Object.keys(state.selectionCache).forEach(key => {
	if (key !== payload.id) {
	    const intersection =  Object.keys(state.facets[payload.id].children).filter(function(n) {
		return Object.keys(state.selectionCache[key]).indexOf(n) !== -1;});
            intersection.forEach(element => {
		activeFilters[element] = state.selectionCache[key][element];});
	}
    });

    // Object.keys(prevSelection).forEach(key => {
    //     if (key !== "hovedfasett") {
    //         if (activeFilters[key]){
    //             prevSelection[key].forEach(item =>{
    //                 let exists = false;
    //                 activeFilters[key].some(i => {
    //                     if (i.value === item.value) {
    //                         exists = true;
    //                         return true;
    //                     }
    //                 })
    //                 if (!exists) activeFilters[key].push(item);    
    //             })
    //         } else {
    //             activeFilters[key] = prevSelection[key];
    //         }
    //     }
    // })

    // ... but keep the query_value, if it was decided above that it should be preserved.
    if (queryValue) {
        activeFilters.query_value = queryValue;
    }

    return {
        ...state,
        activeFilters: activeFilters,
        // Deactivate any active group
        activeGroup: null,
        // Deactivate any active middlefacet
        activeGroupWithMiddlefacets: null,
        // Reset to page 1
        thisPage: 1,
    };
};

const _RESET_SEARCH = (state) => {
    const newState = {
        ...state,
        activeFilters: {},
        // Deactivate any active group
        activeGroup: null,
        // Deactivate any active middlefacet
        activeGroupWithMiddlefacets: null,
        // Reset to page 1
        thisPage: 1,
    };

    const activeFilters = {...state.activeFilters};
    if (activeFilters.hovedfasett !== undefined) {
        const hf = activeFilters.hovedfasett.id;
        let newSelectionCache = {...state.selectionCache};
        if (newSelectionCache[hf] !== undefined) {
            delete newSelectionCache[hf];
            newState.selectionCache = newSelectionCache;
        }
    }

    return newState;
};

const _ADD_TO_AVAILABLE_GROUPS = (state, payload) => {
    const groups = payload.groups;
    return {...state, availableGroups: {...state.availableGroups, ...groups}};
};

const _REMOVE_FROM_AVAILABLE_GROUPS = (state, payload) => {
    const groups = payload.groups;
    let availableGroups = {...state.availableGroups};
    groups.forEach(groupID => {
        delete availableGroups[groupID];
    });
    return {...state, availableGroups: availableGroups};
};

const _RESET_AVAILABLE_GROUPS = (state) => {
    return {...state, availableGroups: null};
};

const _ACTIVATE_GROUP = (state, payload) => {
    const id = payload.id;
    return {...state, activeGroup: id};
};

const _CLEAR_ACTIVE_GROUP = (state) => {
    return {...state, activeGroup: null};
};

const _ACTIVATE_GROUP_WITH_MIDDLEFACETS = (state, payload) => {
    const id = payload.id;
    return {...state, activeGroupWithMiddlefacets: id};
};

const _DEACTIVATE_GROUP_WITH_MIDDLEFACETS = (state) => {
    return {...state, activeGroupWithMiddlefacets: null};
};

const _FETCH_FACETS = (state, payload) => {
    const groupID = payload.groupID;
    const facets = {...state.facets};
    const availableGroups = {...state.availableGroups};
    const activeMainFacet = state.activeFilters.hovedfasett.id;

    // If there is a middlefacetID, then this facet comes from a middlefacet.
    if (payload.middlefacetID !== undefined) {
        const middlefacetGroupID = payload.middlefacetGroupID;
        const middlefacetID = payload.middlefacetID;
        // Store the fetched facets in the main facet object
        if (facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children === undefined) {
            facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children = {};
        }
        if (facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children[groupID] === undefined) {
            facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children[groupID] = {};
        }
        facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children[groupID].value = payload.middlefacetGroupValue;
        facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children[groupID].facetName = payload.middlefacetName;
        facets[activeMainFacet].middlefacets[middlefacetGroupID].children[middlefacetID].children[groupID].children = payload.values;

        // ... but the availableGroups is not synced dynamically, so they need to be added there too.
        // @TODO check if there's a way to create a reference between state values, and change the logic as such.
        if (availableGroups[groupID] !== undefined) {
            availableGroups[groupID].children = payload.values;
        }
        else {
            console.log("Problem #1"); // @TODO find pattern and fix
        }
    }
    else {
        facets[activeMainFacet].children[groupID].children = payload.values;
    }    
    return {...state, facets: facets};
};

const _FETCH_MIDDLEFACETS = (state, payload) => {
    const middlefacetID = payload.middlefacetID;
    const facets = {...state.facets};
    const activeMainFacet = state.activeFilters.hovedfasett.id;
    if (facets[activeMainFacet].middlefacets[middlefacetID] !== undefined) {
        facets[activeMainFacet].middlefacets[middlefacetID].children = payload.values;
    }
    else {
        console.log("Problem #2"); // @TODO find pattern and fix
    }
    return {...state, facets: facets};
};

const _ACTIVATE_FACET = (state, payload) => {
    const id = payload.id;
    const value = payload.value;
    const facetName = payload.facetName;

    const activeFilters = {...state.activeFilters};
    activeFilters[facetName] = {
        id: id,
        value: value
    };
    let newCache = {...state.selectionCache};
    if (!newCache[activeFilters.hovedfasett.id]) newCache[activeFilters.hovedfasett.id] = {};
    newCache[activeFilters.hovedfasett.id][facetName] = activeFilters[facetName];
    
    return {
        ...state,
        activeFilters: activeFilters,
        selectionCache: newCache,
        // Reset to page 1
        thisPage: 1,
    };
};

const _ACTIVATE_FACET_MULTI = (state, payload) => {
    const id = payload.id;
    const value = payload.value;
    const facetName = payload.facetName;

    const activeFilters = {...state.activeFilters};
    if (activeFilters[facetName] === undefined) {
        activeFilters[facetName] = [];
    }

    activeFilters[facetName].push({
        id: id,
        value: value
    });
    let newCache = {...state.selectionCache};
    if (!newCache[activeFilters.hovedfasett.id]) newCache[activeFilters.hovedfasett.id] = {};
    newCache[activeFilters.hovedfasett.id][facetName] = activeFilters[facetName];
    return {
        ...state,
        activeFilters: activeFilters,
        selectionCache: newCache,
        // Reset to page 1
        thisPage: 1,
    };
};

const _DEACTIVATE_FACET = (state, payload) => {
    const newState = {...state};
    const facetName = payload.facetName;

    const activeFilters = {...state.activeFilters};
    const activeMainFacetID = activeFilters.hovedfasett.id;

    const selectionCache = {...state.selectionCache};

    delete activeFilters[facetName];

    newState.activeFilters = activeFilters;
    newState.thisPage = 1;

    if (selectionCache[activeMainFacetID] !== undefined) {
        if (selectionCache[activeMainFacetID][facetName] !== undefined) {
            delete selectionCache[activeMainFacetID][facetName];
        }
    }
    newState.selectionCache = selectionCache;

    return newState;
};

const _DEACTIVATE_FACET_MULTI = (state, payload) => {
    const newState = {...state};
    const facetValue = payload.value;
    const facetName = payload.facetName;

    const activeFilters = {...state.activeFilters};

    let i = activeFilters[facetName].length;
    while (i--) {
        if (activeFilters[facetName][i].value === facetValue) {
            activeFilters[facetName].splice(i, 1);
            break;
        }
    }

    // If we have just deleted the last element, remove the facet completely.
    if (activeFilters[facetName].length === 0) {
        delete activeFilters[facetName];
    }

    newState.activeFilters = activeFilters;
    newState.thisPage = 1;

    return newState;
};

const _DEACTIVATE_DEPENDENT_FACETS = (state, payload) => {
    const newState = {...state};

    const facetsToUnset = payload.facetsToUnset;
    const activeFilters = {...state.activeFilters};
    facetsToUnset.forEach(facetName => {
        delete activeFilters[facetName];
    });

    newState.activeFilters = activeFilters;
    newState.thisPage = 1;

    const activeMainFacetID = payload.activeMainFacetID;
    const selectionCache = {...state.selectionCache};
    if (selectionCache[activeMainFacetID] !== undefined) {
        facetsToUnset.forEach(facetName => {
            if (selectionCache[activeMainFacetID][facetName] !== undefined) {
                delete selectionCache[activeMainFacetID][facetName];
            }
        });
    }
    newState.selectionCache = selectionCache;

    return newState;
}

const _SHOW_RESULTS = (state, payload) => {
    const thisPage = payload.thisPage;
    const lastPage = payload.lastPage;
    const itemsPerPage = payload.itemsPerPage;
    const searchResults = payload.searchResults;
    const totalItems = payload.totalItems;

    return {
        ...state,
        searchResults: searchResults,
        thisPage: thisPage,
        lastPage: lastPage,
        itemsPerPage: itemsPerPage,
        totalItems: totalItems,
        loading: false,
    };
};

const _SET_RESULTS_ERROR = (state, payload) => {
    let errors = {...state.errors};
    errors.results = payload;
    return {...state, errors: errors};
}

const _UNSET_RESULTS_ERROR = (state, payload) => {
    let errors = {...state.errors};
    delete errors.results;
    return {...state, errors: errors};
}

const _GOTO_PAGE = (state, payload) => {
    const page = payload.page;
    return {
        ...state,
        thisPage: page,
        loading: true,
    };
};

const _SHOW_MENU = (state, payload) => {
    return {
        ...state,
        showDesktopMenu: true,
        showMobileMenu: true,
    };
};

const _HIDE_MENU = (state, payload) => {
    return {
        ...state,
        showDesktopMenu: false,
        showMobileMenu: false,
    };
};

const _TOGGLE_MENU = (state, payload) => {
    return {
        ...state,
        showDesktopMenu: !state.showDesktopMenu,
        showMobileMenu: !state.showMobileMenu,
    };
};

const _SET_SEARCH_VALUE = (state, payload) => {
    return {
        ...state,
        acSearchInputValue: payload.acSearchInputValue,
        acOverlay: (payload.acOverlay !== undefined) ? payload.acOverlay : (payload.acSearchInputValue.trim().length >= 2),
        acKeyboardPosition: null, // null out the keyboard search position every time the results are expected to change
    };
};

const _FETCH_AUTOCOMPLETE_RESULTS = (state, payload) => {
    return {
        ...state,
        acSearchResult: payload.acSearchResult,
    };
};

const _CLOSE_OVERLAY = (state, payload) => {
    return {
        ...state,
        acOverlay: false,
    };
};

const _OPEN_OVERLAY = (state, payload) => {
    return {
        ...state,
        acOverlay: true,
    };
};

const _UNSET_SEARCH_VALUE = (state, payload) => {
    const activeFilters = {...state.activeFilters};
    delete activeFilters.query_value;
    if (activeFilters.query_fields !== undefined) {
        delete activeFilters.query_fields;
    }

    return {
        ...state,
        acSearchResult: null,
        acOverlay: false,
        submittedSearchValue: '',
        thisPage: 1,
        activeFilters: activeFilters
    };
};

const _SUBMIT_SEARCH_VALUE = (state, payload) => {
    const activeFilters = {...state.activeFilters};

    // KI-20
    if (activeFilters.type && activeFilters.type !== undefined) {
        delete activeFilters.type;
    }

    if (payload) {
        activeFilters.query_value = {value: payload};
    }
    else {
        delete activeFilters.query_value;
    }
    // The query_fields should only be set by a direct link to the search page, not through the app.
    if (activeFilters.query_fields !== undefined) {
        delete activeFilters.query_fields;
    }

    return {
        ...state,
        submittedSearchValue: payload,
        activeFilters: activeFilters,
        thisPage: 1
    };
};

const _SET_MOBILE = (state, payload) => {
    return {
        ...state,
        isMobile: payload,
    };
}

const _SET_KEYBOARD_POSITION = (state, payload) => {
    return {
        ...state,
        acKeyboardPosition: payload,
    };
}

// Note: I outsource all actions to their own functions to make code handling easier.
const newFilterReducer = (state = initialState, action) => {
    switch (action.type) {

        case INITIALIZE:
            return _INITIALIZE(state, action.payload);

        case CACHE_RESPONSE:
            return _CACHE_RESPONSE(state, action.payload);

        case SET_INITIAL_ACTIVE_FILTERS:
            return _SET_INITIAL_ACTIVE_FILTERS(state, action.payload);

        case SET_ACTIVE_FILTER_ID:
            return _SET_ACTIVE_FILTER_ID(state, action.payload);

        case FETCH_MAIN_FACETS:
            return _GET_MAIN_FACETS(state, action.payload);

        case MAIN_FACETS_ERROR:
            return _MAIN_FACETS_ERROR(state, action.payload);

        case UPDATE_MAIN_FACETS_COUNT:
            return _UPDATE_MAIN_FACETS_COUNT(state, action.payload);

        case ACTIVATE_MAIN_FACET:
            return _ACTIVATE_MAIN_FACET(state, action.payload);

        case ACTIVATE_GROUP:
            return _ACTIVATE_GROUP(state, action.payload);

        case CLEAR_ACTIVE_GROUP:
            return _CLEAR_ACTIVE_GROUP(state, action.payload);

        case FETCH_MIDDLEFACETS:
            return _FETCH_MIDDLEFACETS(state, action.payload);

        case FETCH_FACETS:
            return _FETCH_FACETS(state, action.payload);

        case ACTIVATE_FACET:
            return _ACTIVATE_FACET(state, action.payload);

        case ACTIVATE_FACET_MULTI:
            return _ACTIVATE_FACET_MULTI(state, action.payload);

        case DEACTIVATE_FACET:
            return _DEACTIVATE_FACET(state, action.payload);

        case DEACTIVATE_FACET_MULTI:
            return _DEACTIVATE_FACET_MULTI(state, action.payload);

        case DEACTIVATE_DEPENDENT_FACETS:
            return _DEACTIVATE_DEPENDENT_FACETS(state, action.payload);

        case ACTIVATE_GROUP_WITH_MIDDLEFACETS:
            return _ACTIVATE_GROUP_WITH_MIDDLEFACETS(state, action.payload);

        case DEACTIVATE_GROUP_WITH_MIDDLEFACETS:
            return _DEACTIVATE_GROUP_WITH_MIDDLEFACETS(state);

        case ADD_TO_AVAILABLE_GROUPS:
            return _ADD_TO_AVAILABLE_GROUPS(state, action.payload);

        case RESET_AVAILABLE_GROUPS:
            return _RESET_AVAILABLE_GROUPS(state, action.payload);

        case REMOVE_FROM_AVAILABLE_GROUPS:
            return _REMOVE_FROM_AVAILABLE_GROUPS(state, action.payload);

        case RESET_SEARCH:
            return _RESET_SEARCH(state);

        case SHOW_RESULTS:
            return _SHOW_RESULTS(state, action.payload);

        case SET_RESULTS_ERROR:
            return _SET_RESULTS_ERROR(state, action.payload);

        case UNSET_RESULTS_ERROR:
            return _UNSET_RESULTS_ERROR(state, action.payload);

        case GOTO_PAGE:
            return _GOTO_PAGE(state, action.payload);

        case SHOW_MENU:
            return _SHOW_MENU(state, action.payload);

        case HIDE_MENU:
            return _HIDE_MENU(state, action.payload);

        case TOGGLE_MENU:
            return _TOGGLE_MENU(state, action.payload);

        case SET_SEARCH_VALUE:
            return _SET_SEARCH_VALUE(state, action.payload);

        case FETCH_AUTOCOMPLETE_RESULTS:
            return _FETCH_AUTOCOMPLETE_RESULTS(state, action.payload);

        case CLOSE_OVERLAY:
            return _CLOSE_OVERLAY(state, action.payload);

        case OPEN_OVERLAY:
            return _OPEN_OVERLAY(state, action.payload);

        case UNSET_SEARCH_VALUE:
            return _UNSET_SEARCH_VALUE(state, action.payload);

        case SUBMIT_SEARCH_VALUE:
            return _SUBMIT_SEARCH_VALUE(state, action.payload);

        case SET_MOBILE:
            return _SET_MOBILE(state, action.payload);

        case SET_KEYBOARD_POSITION:
            return _SET_KEYBOARD_POSITION(state, action.payload);
        default:
            return state;
    }
};

export default newFilterReducer;
